// extracted by mini-css-extract-plugin
export default {"container":"SetList_container__swxZa","setListWrapper":"SetList_setListWrapper__lrfIb"};